exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ag-grid-date-picker{padding:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/reports/shared/components/ag-grid-date-picker/index.scss
// module id = 5198
// module chunks = 0